<p-confirmDialog key="addgroup" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Input-->
<div class="asg-Grid">
	<label>Group Name:</label>
	<input [disabled]="loading == true" [(ngModel)]="GroupName" class="form-control" style="min-width: 300px" type="text" />
</div>

<!--Buttons-->
<div class="groups-PopupButtons">
	<button [disabled]="loading == true" class="btn btn-primary" (click)="onAdd()">Add Group</button>
	<button [disabled]="loading == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<div class="form-group TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
